module.exports = __webpack_public_path__ + "dd25615c99cf30c03e9fffcf527b1e4e.MP3";